export const EMPTY_SPACE = " ";
